export default __webpack_public_path__ + "plus-symbol-in-a-rounded-black-square.png";